export default {
    overallScoreColor: function overallScoreColor(score) {
      if (score >= 90) return "green darken-2";
      if (score >= 80) return "green";
      if (score >= 70) return "light-green text--darken-1";
      if (score >= 60) return "yellow darken-2";
      if (score >= 50) return "amber darken-2";
      if (score >= 40) return "orange darken-2";
      if (score >= 30) return "deep-orange darken-2";
      return "red darken-2";
    },
    overallScoreTextColor: function overallScoreTextColor(score) {
      if (score >= 90) return "green--text text--darken-2";
      if (score >= 80) return "green--text";
      if (score >= 70) return "light-green--text text--darken-1";
      if (score >= 60) return "yellow--text text--darken-2";
      if (score >= 50) return "amber--text text--darken-2";
      if (score >= 40) return "orange--text text--darken-2";
      if (score >= 30) return "deep-orange--text text--darken-2";
      return "red--text text--darken-2";
    },
    leftBorderColorForTier: function leftBorderColorForTier(tier) {
        if (tier === 101) return "left-border-orange";
        if (tier === 105) return "left-border-blue";
        if (tier === 110) return "left-border-purple";
        return "";
    },
    textColorForTier: function textColorForTier(tier) {
        if (tier === 101) return "orange--text";
        if (tier === 105) return "blue--text";
        if (tier === 110) return "purple--text";
        return "";
    }
}